import { AgEditorComponent } from "@bfx/ag-grid-angular";

import { AfterViewInit, Component, ViewChild, ElementRef } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxCheckboxIconSmallComponent } from "../../bfx-element-library/bfx-checkbox-icon-small.component";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "df-check-box",
  templateUrl: "./html/DfCheckBox.html",
  standalone: false,
})
export class DfCheckBox
  extends BfxCheckboxIconSmallComponent
  implements AgEditorComponent, AfterViewInit
{
  // @ViewChild('inputField') inputField: ElementRef;
  @ViewChild("inputField", { read: ElementRef, static: true })
  inputField: ElementRef;
  public canOverRideStp: boolean;
  private isComponentLeg: boolean;
  protected isRowSelected: boolean;
  constructor() {
    super();
  }

  getValue(): any {
    return this.checked;
  }

  agInit(params: any): void {
    this.canOverRideStp = params.node.data.canOverRideStp;
    this.isComponentLeg = params.node.data.isComponentLeg;
    this.isRowSelected = params.node.isSelected();
    if (
      !this.canOverRideStp ||
      this.isComponentLeg ||
      (!this.isComponentLeg && !this.isRowSelected)
    )
      return;
    this.checked = params.value;
  }

  // No neeed, default is false
  // isPopup?(): boolean{
  //     return false;
  // }

  isCancelBeforeStart?(): boolean {
    return (
      !this.canOverRideStp || this.isComponentLeg || (!this.isComponentLeg && !this.isRowSelected)
    );
  }

  isCancelAfterEnd?(): boolean {
    return (
      !this.canOverRideStp || this.isComponentLeg || (!this.isComponentLeg && !this.isRowSelected)
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // not happy with this, but have to set focus to the hidden helper input field
      // if not editor doesnt take focus when tabbed to, so cant change value and cant tab away
      this.inputField.nativeElement.children[0].children[0].children[0].focus();
    });
  }
}
